<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import videoComponent from "./production/video-component-output-tab.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  components: {
    videoComponent,
  },
  name: "OutputsTab",
  data() {
    return {
      floppyDisk,
    };
  },
  computed: {
    ...mapGetters({
      currentActivity: "workouts/currentActivity",
      currentVideos: "workouts/currentVideos",
    }),

    workout_chapterisation_short_description: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "workout_chapterisation_short_description",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.workout_chapterisation_short_description;
        }
        return "";
      },
    },
    workout_chapterisation_long_description: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "workout_chapterisation_long_description",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.workout_chapterisation_long_description;
        }
        return "";
      },
    },
  },

  methods: {
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("workouts/updateActivity", this.$route.params.id)
        .then((res) => {
          this.$store
            .dispatch("workouts/updateVideo", this.$route.params.id)
            .then((res) => {
              this.$store.commit(`commons/setSavingForm`, "Saved");
              this.$store.commit(`workouts/setTabStatus`, false);
              this.$store.commit("commons/setPreloader", false);
            });
        });
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    liveCountDown: function () {
      this.totalRemainCount =
        this.shortDescriptionLimitCount -
        this.workout_chapterisation_short_description.length;
      this.generateErr = this.totalRemainCount < 0;
    },
  },
  async mounted() {
    if (this.currentActivity.id)
      this.$store.dispatch(
        `workouts/getCurrentVideos`,
        this.currentActivity.id
      );
  },
};
</script>

<template>
  <div class="px-5 py-5">
    <video-component
      v-for="(video, index) of currentVideos"
      :key="index"
      :index="index"
      :video="video"
    >
    </video-component>

    <button class="floating-btn btn no-outline" @click="updateActivity()">
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
  </div>
</template>